import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Component } from 'react';
import canUseDom from 'dom-helpers/util/inDOM';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
var portalContainer;

var Portal =
/*#__PURE__*/
function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Portal).call(this)); // This fixes SSR

    if (!canUseDom) return _possibleConstructorReturn(_this);

    if (!portalContainer) {
      portalContainer = document.createElement('div');
      portalContainer.setAttribute('evergreen-portal-container', '');
      document.body.appendChild(portalContainer);
    }

    _this.el = document.createElement('div');
    portalContainer.appendChild(_this.el);
    return _this;
  }

  _createClass(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      portalContainer.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      // This fixes SSR
      if (!canUseDom) return null;
      return ReactDOM.createPortal(this.props.children, this.el);
    }
  }]);

  return Portal;
}(Component);

Portal.displayName = "Portal";
export { Portal as default };
Portal.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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